import * as Sentry from '@sentry/vue';

export class SentryUtil {
  static fallback(reason: string) {
    Sentry.captureException(new Error(`Fallback behavior was used. Reason: ${reason}.`), { level: 'warning' });
  }
}
